import AddEditApartmentList from '../../features/admin/AddEditApartmentList'

const AddEditApartmentListPage = () => {
  return (
    <AddEditApartmentList/>
  )
}

export default AddEditApartmentListPage
